import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import MemberCompetencyForm from '../../../components/forms/MemberCompetencyForm';
import { useMemberCompetencyApi } from '../../../hooks/useMemberCompetencyApi';
import { useNavigate, useParams } from 'react-router-dom';
import { MemberCompetencyDTO } from '../../../services/apiClient';

const MemberCompetencyEdit: React.FC = () => {
  const { getById, edit } = useMemberCompetencyApi();
  const [entityData, setEntityData] = useState<MemberCompetencyDTO | null>(
    null,
  );
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Competencies', href: '/admin/membercompetencies' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching MemberCompetency data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await edit(id!, data);
      navigate('/admin/membercompetencies');
    } catch (error) {
      console.error('Error updating MemberCompetency:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/membercompetencies"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin', 'User']}
      requiredPermission="Manage.MemberCompetency.Edit"
    >
      {entityData ? (
        <MemberCompetencyForm
          initialValues={entityData}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/membercompetencies')}
          isLoading={isSubmitting}
        />
      ) : (
        <p>Loading...</p>
      )}
    </AdminLayout>
  );
};

export default MemberCompetencyEdit;
